import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

/** 행사 보험정보 */
interface EventInsurance {
	atteInfo: string;
	insuTempNm: string;
	rewordId: string;
	insuType: string;
	goodsTp: string;
}

/** ```
 * 행사의 보험정보 조회
 *   `/pkg/insurance/by-event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventInsurance";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/insurance/by-event/${evCd}`;
};

/** ```
 * 행사의 보험정보 조회
 *   `/pkg/insurance/by-event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventInsurance = (evCd: string, options?: Partial<UseQueryOptions<Response<EventInsurance>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventInsurance;
export {getPath};
export type {EventInsurance};
